export default __webpack_public_path__ + "static/media/IMS.c086be36.png";